import React from 'react';

import {VisibilityOff, Visibility} from '@material-ui/icons';
import {IconButton} from '@material-ui/core';

import './styles.scss';

export default ({value}) => {
  const [shown, setShownState] = React.useState();
  const VisibilityIcon = shown ? VisibilityOff : Visibility;

  return (
    <div className="terminal-passcode">
      <div className="terminal-passcode__text">
        {shown ? value : '******'}
      </div>
      <IconButton
        className="terminal-passcode__btn"
        onClick={() => {
          setShownState(!shown);
        }}
      >
        <VisibilityIcon/>
      </IconButton>
    </div>
  );
};
